export const interpolateNS: (namespace: string) => (key: string) => string = (ns) => (key) => `${ns}:${key}`;
